import {HttpService} from 'api/HttpService';
import handleApiError from 'utils/api/errors/handleApiError';
import ApiBadRequestError from 'utils/api/errors/ApiBadRequestError';
import BatchRequestsQueue from 'api/BatchRequests/BatchRequestsQueue';
import BatchRequestItem from 'api/BatchRequests/BatchRequestItem';


const BATCH_REQUEST_API_URL = '/api/batch';


class HttpBatchService extends HttpService {
  constructor () {
    super();

    this.requestsQueue = new BatchRequestsQueue();
  }

  processResponseItem (response, batchResponses, responseIdx) {
    const targetBatchItem = batchResponses[responseIdx];
    if (response.status !== 200) {
      try {
        handleApiError(response);
      } catch (e) {
        if (e instanceof ApiBadRequestError) {

          // override errors, because they have no axios error object, and XXXApiError have different structure
          let errorsObject = {};
          let errorMessage = '';
          let errorTitle = '';

          if (response.body.errors) {
            errorsObject = response.body.errors;
          }

          if (response.body.errors && response.body.errors.message) {
            errorMessage = response.body.errors.message;
          }

          if (response.body.errors && response.body.errors.title) {
            errorTitle = response.body.errors.title;
          }

          e.setValidationErrors(errorsObject);
          e.setErrorMessage(errorMessage);
          e.setTitleMessage(errorTitle);

          console.warn(
            `[BatchRequests] Failed request [${responseIdx + 1} of ${batchResponses.length}] with error ${e.name}`
          );
        }


        return targetBatchItem.rejectPromise(e);
      }
    }

    targetBatchItem.resolvePromise(
      targetBatchItem.wrapResponse(response.body)
    );
  }

  async makeBatchRequest () {
    const requestItems = this.requestsQueue.dequeueAll();
    if (requestItems.length === 0) {
      console.warn('[HttpBatchService] no data to request');
      return;
    }

    const requestParams = requestItems.map(r => r.getParams());

    const response = await super.post(
      BATCH_REQUEST_API_URL,
      {
        requests: requestParams
      });

    const items = response.data.items;
    items.forEach((i, idx) => this.processResponseItem(i, requestItems, idx));
  }

  post (url, payload, params = {}, axiosParams = {}) {
    const item = new BatchRequestItem({
      method: 'POST',
      url,
      payload,
      params,
      axiosParams
    });

    this.requestsQueue.enqueue(item);

    return item.getPromise();
  }

  async put (url, payload, params = {}, axiosParams = {}) {
    const item = new BatchRequestItem({
      method: 'PUT',
      url,
      payload,
      params,
      axiosParams
    });

    this.requestsQueue.enqueue(item);

    return item.getPromise();
  }

  async get (url, getParams, params = {}, axiosParams = {}, clientParams = {}) {
    const item = new BatchRequestItem({
      method: 'GET',
      url,
      queryParams: getParams,
      params,
      axiosParams,
      clientParams
    });

    this.requestsQueue.enqueue(item);

    return item.getPromise();
  }

  async delete (url, queryParams = {}, payload = {}, params = {}, axiosParams = {}) {
    const item = new BatchRequestItem({
      method: 'DELETE',
      url,
      payload,
      queryParams,
      params,
      axiosParams
    });

    this.requestsQueue.enqueue(item);

    return item.getPromise();
  }
}


export default new HttpBatchService();
